/**
 * @generated SignedSource<<d71a116571d29ae0ecbc6e6c392b2c65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeSidebar_whatToSee$data = {
  readonly seo: {
    readonly slug: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "WhatToSeeSidebar_whatToSee";
};
export type WhatToSeeSidebar_whatToSee$key = {
  readonly " $data"?: WhatToSeeSidebar_whatToSee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeSidebar_whatToSee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeSidebar_whatToSee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seo",
      "kind": "LinkedField",
      "name": "seo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "WhatToSee",
  "abstractKey": null
};

(node as any).hash = "57edb8e6787457d88758c9f406715767";

export default node;
